import debounce from 'lodash/debounce';
import fetcher from '../modules/ajio-fetch';
import { setErrorObject } from './shared/HTTPError';

import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  tokenReCreateParser
} from '../modules/ajio-fetch/utils';
import isNode from '../modules/ajio-util/isNode';
import { createCookie, readCookie } from '../components/common/Cookie';

import { createAnonymousLogin } from './authUser';
import { hideLoader, showLoader } from './loader';
import { addedToCart, addedToCartMembership, putMinicartData, selectSizeError } from './productData';
import { hideModal, showModal } from './modal.js';
import { getCartWishlistCounts, cartWishlistCount } from './homeData';
import { getCart } from '../cart/actions/cart';
import properties from '../modules/ajio-util/properties';
import { gtmEventPush } from '../modules/ga/GTMdatalayer';

import { createToken } from './shared/newsLetter';
import { getDressToolAtcPopupConfig } from '../refresh/selectors/featureFlagsSelector';
import { atcDressToolInitiate } from './shared/braRecommendation';


function hideLoaders(status, deviceType) {
  return function(dispatch, getState) {
    // dispatch(hideLoader("quick-view-loader"));
    const timeoutAfterAddingToBag = setTimeout(() => {
      dispatch(hideLoader('quick-view-loader'));
      clearTimeout(timeoutAfterAddingToBag);
    }, 2000);

    const timeoutToShowCart = setTimeout(() => {
      dispatch(hideLoader('add-to-bag'));
      clearTimeout(timeoutToShowCart);
    }, 2000);

    const state = getState();
    const { brickCategory, brickName } = state.product?.productDetails || {};
    const dressToolConfig = getDressToolAtcPopupConfig(state);
    const dressToolVisibility =
      dressToolConfig?.showPopup && dressToolConfig?.imgUrl && dressToolConfig?.imgUrl?.length>0 && 
      dressToolConfig?.visibilityConditions[brickCategory]
        ?.map(name => name.trim())
      .includes(brickName);

    if (dressToolVisibility) {
      const timeoutToShowDressTool = setTimeout(() => {
        dispatch(showModal('dress-tool-atc-modal'));
        dispatch(atcDressToolInitiate());                    //for product atc initiate bra recommendation modal
        clearTimeout(timeoutToShowDressTool);
      }, 2000);
    }
    if (status === 'success') {
      dispatch(hideModal('quickview-modal'));
      const timeoutToShowCart = setTimeout(() => {
        dispatch(addedToCart(true));
        clearTimeout(timeoutToShowCart);
      }, 500);

      const timeoutToHideCart = setTimeout(() => {
        dispatch(addedToCart(false));
        clearTimeout(timeoutToHideCart);
      }, 3000);

      if (deviceType === 'desktop') {
        dispatch(getMinicartData());
      } else {
        dispatch(getCartWishlistCounts());
      }
    }
  };
}

function hideLoadersForMembership(status, deviceType) {
  return function(dispatch) {
    const timeoutToShowCart = setTimeout(() => {
      dispatch(hideLoader('add-to-bag-membership'));
      clearTimeout(timeoutToShowCart);
    }, 2000);
    if (status === 'success') {
      const timeoutToShowCart = setTimeout(() => {
        dispatch(addedToCartMembership());
        clearTimeout(timeoutToShowCart);
      }, 1500);

      if (deviceType === 'desktop') {
        dispatch(getMinicartData());
        // dispatch(getCart({isRequestOrginIsBrowser:true}));
      } else {
        dispatch(getCartWishlistCounts());
      }
    }
  };
}

function showLoaders() {
  return function(dispatch) {
    // dispatch(hideModal("quickview-modal"));
    dispatch(hideModal('cart-size-modal'));
    dispatch(showLoader('quick-view-loader'));
    dispatch(showLoader('add-to-bag'));
  };
}

function showLoadersForMembership() {
  return function(dispatch) {
    dispatch(showLoader('add-to-bag-membership'));
  };
}

function setOutOfStockStatus(productId) {
  return {
    type: 'SET_OUT_OF_STOCK',
    productId
  };
}
function resetOutOfStockStatus() {
  return {
    type: 'RESET_OUT_OF_STOCK'
  };
}

function showErrorMessage(errorObj, productId) {
  return function(dispatch) {
    const { errorMessage: { errors = [] } = {} } = errorObj || {};
    const [{ type, reason = '' } = {}] = errors.length ? errors : [{ ...errorObj }];

    if (type === 'CommerceCartModificationError') {
      // if condition is not required as we are checking `type === "CommerceCartModificationError"`
      // extra if condition is just for safe
      if (reason === 'INSUFFICIENT_STOCK' || reason === 'UNAVAILABLE_STOCK') {
        dispatch(setOutOfStockStatus(productId));
        // if (errorObj.message === "Sorry, there is insufficient stock for your cart.") {
        //   errorObj = { ...errorObj, message: "Your size could not be added to bag" };
        // }
      }
    }
    gtmEventPush({ event: 'page_error', error_message: errorObj.message });

    dispatch(hideLoader('quick-view-loader'));
    dispatch(hideLoader('add-to-bag'));
    dispatch(setErrorObject(errorObj));
    const timeout = setTimeout(() => {
      dispatch(setErrorObject({}));
      clearTimeout(timeout);
    }, 5000);
  };
}

function showErrorMessageForMembership(errorObj, productId) {
  return function(dispatch) {
    const { errorMessage: { errors = [] } = {} } = errorObj || {};
    const [{ type, reason = '' } = {}] = errors.length ? errors : [{ ...errorObj }];

    gtmEventPush({ event: 'page_error', error_message: errorObj.message });

    dispatch(hideLoader('add-to-bag-membership'));
    dispatch(setErrorObject(errorObj));
    const timeout = setTimeout(() => {
      dispatch(setErrorObject({}));
      clearTimeout(timeout);
    }, 5000);
  };
}

function addedToCartError(cartError, cartResponse) {
  return {
    type: 'ADD_TO_CART_ERROR',
    cartError,
    cartResponse
  };
}

export function addToCart(
  productId,
  deviceType,
  isRecursivelyCalling = false,
  successCallback,
  imsBatchId,
  commercialType = ''
) {
  return function(dispatch) {
    const user = readCookie('U');
    const aguid = readCookie('AGUID');
    let cart = readCookie('C');
    console.log('FROM FLEEK adtocart', productId);
    /**
     * If CartId exists guest user and loggedIn user try to add product into cart
     */
    if (user != 'anonymous' && cart === aguid) {
      cart = '';
    }
    // not aware of usage commenting it to fixed prod issue 188582
    // dispatch(resetOutOfStockStatus());
    dispatch(showLoaders());
    if (cart) {
      // add product directly to the cart
      addProductToCart(productId, imsBatchId, commercialType)
        .then(response => {
          const { isResponseFromPE } = response;
          // to do integrate ga
          // ga('send', {
          //   eventCategory: 'Experiment',
          //   eventAction: 'PE_RollOut_ADD_TO_CART',
          //   eventLabel: `PE_RollOut_ADD_TO_CART_${isResponseFromPE}`
          // });
          dispatch(hideLoaders('success', deviceType));
          if (successCallback) {
            successCallback();
          }
        })
        .catch(error => {
          const statusCode = getErrorStatusCode(error);
          errorParser(error, statusCode).then((errorObj = {}) => {
            const { reason = '' } = errorObj;
            if (statusCode === 401) {
              tokenReCreateParser(statusCode, errorObj).then(() => {
                addProductToCart(productId, imsBatchId, commercialType)
                  .then(response => {
                    dispatch(hideLoaders('success', deviceType));
                    if (successCallback) {
                      successCallback();
                    }
                  })
                  .catch(error => {
                    const statusCode = getErrorStatusCode(error);
                    errorParser(error, statusCode).then((errorObj = {}) => {
                      if (statusCode !== 401) {
                        if (!isRecursivelyCalling) {
                          return addToCart(
                            productId,
                            deviceType,
                            true,
                            successCallback,
                            imsBatchId,
                            commercialType
                          )(dispatch);
                        }
                        dispatch(showErrorMessage(errorObj, productId));
                      }
                    });
                    dispatch(hideLoaders('error'));
                  });
              });
            } else if (statusCode === 400 && reason.toLowerCase() === 'notfound') {
              createCart({ user })
                .then(({ code }) => addProductToCart(productId, imsBatchId, commercialType))
                .then(response => {
                  dispatch(hideLoaders('success', deviceType));
                  if (successCallback) {
                    successCallback();
                  }
                })
                .catch(error => {
                  const statusCode = getErrorStatusCode(error);
                  errorParser(error, statusCode).then((errorObj = {}) => {
                    dispatch(showErrorMessage(errorObj, productId));
                  });
                  dispatch(hideLoaders('error'));
                });
            } else {
              dispatch(showErrorMessage(errorObj, productId));
            }
          });
        });
    } else if (!cart && user && user != 'anonymous') {
      createCart({ user })
        .then(({ code }) => addProductToCart(productId, imsBatchId, commercialType))
        .then(response => {
          dispatch(hideLoaders('success', deviceType));
          if (successCallback) {
            successCallback();
          }
        })
        .catch(error => {
          const statusCode = getErrorStatusCode(error);
          errorParser(error, statusCode).then((errorObj = {}) => {
            dispatch(showErrorMessage(errorObj, productId));
          });
          dispatch(hideLoaders('error'));
        });
    } else {
      createToken()
        .then(token => createCart({ user }))
        .then(({ code }) => addProductToCart(productId, imsBatchId, commercialType))
        .then(response => {
          dispatch(hideLoaders('success', deviceType));
          if (successCallback) {
            successCallback();
          }
        })
        .catch(error => {
          const statusCode = getErrorStatusCode(error);
          errorParser(error, statusCode).then((errorObj = {}) => {
            dispatch(showErrorMessage(errorObj, productId));
          });
          dispatch(hideLoaders('erorr'));
        });
    }
  };
}

export function addMembershipToCart(
  productId,
  deviceType,
  isRecursivelyCalling = false,
  successCallback,
  imsBatchId,
  commercialType = ''
) {
  return function(dispatch) {
    const user = readCookie('U');
    const aguid = readCookie('AGUID');
    let cart = readCookie('C');
    /**
     * If CartId exists guest user and loggedIn user try to add product into cart
     */
    if (user != 'anonymous' && cart === aguid) {
      cart = '';
    }
    dispatch(showLoadersForMembership());
    if (cart) {
      // add product directly to the cart
      addProductToCart(productId, imsBatchId, commercialType)
        .then(response => {
          const { isResponseFromPE } = response;
          dispatch(hideLoadersForMembership('success', deviceType));
          if (successCallback) {
            successCallback();
          }
        })
        .catch(error => {
          const statusCode = getErrorStatusCode(error);
          errorParser(error, statusCode).then((errorObj = {}) => {
            const { reason = '' } = errorObj;
            if (statusCode === 401) {
              tokenReCreateParser(statusCode, errorObj).then(() => {
                addProductToCart(productId, imsBatchId, commercialType)
                  .then(response => {
                    dispatch(hideLoadersForMembership('success', deviceType));
                    if (successCallback) {
                      successCallback();
                    }
                  })
                  .catch(error => {
                    const statusCode = getErrorStatusCode(error);
                    errorParser(error, statusCode).then((errorObj = {}) => {
                      if (statusCode !== 401) {
                        if (!isRecursivelyCalling) {
                          return addMembershipToCart(
                            productId,
                            deviceType,
                            true,
                            successCallback,
                            imsBatchId,
                            commercialType
                          )(dispatch);
                        }
                        dispatch(showErrorMessageForMembership(errorObj, productId));
                      }
                    });
                    dispatch(hideLoadersForMembership('error'));
                  });
              });
            } else if (statusCode === 400 && reason.toLowerCase() === 'notfound') {
              createCart({ user })
                .then(({ code }) => addProductToCart(productId, imsBatchId, commercialType))
                .then(response => {
                  dispatch(hideLoadersForMembership('success', deviceType));
                  if (successCallback) {
                    successCallback();
                  }
                })
                .catch(error => {
                  const statusCode = getErrorStatusCode(error);
                  errorParser(error, statusCode).then((errorObj = {}) => {
                    dispatch(showErrorMessageForMembership(errorObj, productId));
                  });
                  dispatch(hideLoadersForMembership('error'));
                });
            } else {
              dispatch(showErrorMessageForMembership(errorObj, productId));
            }
          });
        });
    } else if (!cart && user && user != 'anonymous') {
      createCart({ user })
        .then(({ code }) => addProductToCart(productId, imsBatchId, commercialType))
        .then(response => {
          dispatch(hideLoadersForMembership('success', deviceType));
          if (successCallback) {
            successCallback();
          }
        })
        .catch(error => {
          const statusCode = getErrorStatusCode(error);
          errorParser(error, statusCode).then((errorObj = {}) => {
            dispatch(showErrorMessageForMembership(errorObj, productId));
          });
          dispatch(hideLoadersForMembership('error'));
        });
    } else {
      createToken()
        .then(token => createCart({ user }))
        .then(({ code }) => addProductToCart(productId, imsBatchId, commercialType))
        .then(response => {
          dispatch(hideLoadersForMembership('success', deviceType));
          if (successCallback) {
            successCallback();
          }
        })
        .catch(error => {
          const statusCode = getErrorStatusCode(error);
          errorParser(error, statusCode).then((errorObj = {}) => {
            dispatch(showErrorMessageForMembership(errorObj, productId));
          });
          dispatch(hideLoadersForMembership('erorr'));
        });
    }
  };
}

export function createCart(response) {
  let { user = '', accessToken = '', apiEndPoint = '' } = response;
  if (!apiEndPoint) {
    apiEndPoint = `/api/cart/create`;
  }
  return new Promise((resolve, reject) => {
    fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ user, accessToken })
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              createCart(response)
                .then(response => {
                  resolve(response);
                })
                .catch(error => {
                  reject(error);
                });
            });
          } else {
            reject(error);
          }
        });
      });
  });
}

function addProductToCart(productId, imsBatchId, commercialType = '') {
  const user = readCookie('U');
  const cartId = readCookie('C');
  const apiEndPoint = `/api/cart/${cartId}/product/${productId}/add`;
  let bodyData = {
    quantity: 1
  };
  if (imsBatchId) {
    bodyData['imsBatchId'] = imsBatchId;
  }
  if (commercialType) {
    bodyData['commercialType'] = commercialType;
  }
  const body = JSON.stringify(bodyData);
  return new Promise((resolve, reject) => {
    fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body,
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function getMicrocartData(isRecursivelyCalling = false) {
  const apiEndPoint = `/api/cart/microcart`;

  return function(dispatch) {
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const cartCountsData = {
          cartCount: Number(response?.cartCount || 0),
          wishlistCount: 0,
          isMembershipArticlePresent: response?.isMembershipArticlePresent
        };
        dispatch(cartWishlistCount(cartCountsData));
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode).then((errorObj = {}) => {
          const { reason = '' } = errorObj;

          if (statusCode === 401 && !isRecursivelyCalling) {
            return tokenReCreateParser(statusCode, errorObj)
              .then(() => {
                return Promise.resolve(getMicrocartData(true)(dispatch));
              })
              .catch(err => {
                return Promise.reject(err);
              });
          }
          if (statusCode === 400 && reason.toLowerCase() != 'notFound') {
            dispatch(cartWishlistCount({ cartCount: 0, wishlistCount: 0 }));
          } else {
            dispatch(showErrorMessage(errorObj));
          }
        });
      });
  };
}

export function getMinicartData(isRecursivelyCalling = false, setCartCounts = false, requestObj = {}) {
  const apiEndPoint = isNode() ? `${properties.getProperty('parentUrl')}/api/cart/minicart` : `/api/cart/minicart`;
  let cookies = {};
  if (Object.keys(requestObj).length) {
    cookies = {
      A: requestObj.A,
      U: requestObj.U,
      C: requestObj.C
    };
  }
  const cookieValues = JSON.stringify(cookies)
  return function(dispatch) {
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: { 'content-type': 'application/json' , cookieValues},
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(putMinicartData(response));
        if (setCartCounts) {
          const cartCountsData = {
            cartCount: Number(response?.numberItemsInCart || 0),
            wishlistCount: 0
          };
          dispatch(cartWishlistCount(cartCountsData));
        }
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode).then((errorObj = {}) => {
          const { reason = '' } = errorObj;

          if (statusCode === 401 && !isRecursivelyCalling) {
            return tokenReCreateParser(statusCode, errorObj)
              .then(() => {
                return Promise.resolve(getMinicartData(true, setCartCounts)(dispatch));
              })
              .catch(err => {
                return Promise.reject(err);
              });
          }
          if (statusCode === 400 && reason.toLowerCase() != 'notFound') {
            dispatch(putMinicartData({}));
          } else {
            dispatch(showErrorMessage(errorObj));
          }
          if (setCartCounts) {
            dispatch(cartWishlistCount({ cartCount: 0, wishlistCount: 0 }));
          }
        });
      });
  };
}

export function checkSelectedSize(data, selectedSizeCode) {
  return function(dispatch) {
    if (selectedSizeCode) {
      addProduct(selectedSizeCode, dispatch);
    } else {
      dispatch(selectSizeError('Please select a size'));
    }
  };
}

let addProduct = debounce(
  (selectedSizeCode, dispatch) => {
    dispatch(addToCart(selectedSizeCode, 'desktop'));
  },
  3000,
  { leading: true, trailing: false }
);
